module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Mūsų partneriai – rinkoje pirmaujantys prekių ženklai","partnerAltFallback":"Mūsų partneris"}}')
  delete Component.options._Ctor
}
